module.exports = "https://static.energy5.com/_next/static/images/howItWorks-d6ff187123aacd9824129234e0430b87.png";